import React from "react";
import Dialog from '@material-ui/core/Dialog';
import PossibleFEParams from "./PossibleFEParams";
import t from "../../../../helpers/t";
type Props = {
    url: string|null,
    onChange: (item: any, name?: string | undefined) => void,
    handleCloseDialog: () => void
}
const FEParamsDialog = (props: Props) => {
    const { url, onChange, handleCloseDialog } = props;
    return (
        <>
            <Dialog
                onClose={handleCloseDialog}
                aria-labelledby="feParams-dialog-title"
                open={true}
                name="feParamsDialog"
                id="multipleRecipientsDialog"
                // @ts-ignore
                maxWidth={"ld"}
            >
                <header className="inb-multiple-recipients-header">

                    <button
                        onClick={handleCloseDialog}
                        type="button"
                        id="inb-multiple-recipients-dialog-close-button"
                        className="button hollow secondary right button-close-multiple-recipients-dialog round"
                        title={t("close show status")}
                    >
                        <i className="fi fi-x"></i>
                    </button>
                    <h4>{t('frontend url parameter', null, 'capital')}</h4>

                        <div id="inb-c-main-header">
                            <ul className="inb-tabs row">
                                <li className="tabs-title column medium-6">{t('parameter', null, 'capital')}</li>
                                <li className="tabs-title column medium-6" style={{paddingLeft:"30px"}}>{t('value')}</li>
                            </ul>
                        </div>

                </header>
                <div id="inb-c-main-multiple-recipients" className="inb-c-listing off-canvas-content"
                     data-off-canvas-content="">
                    <PossibleFEParams
                        url={url}
                        />
                </div>
            </Dialog>
        </>
    )
}
export default FEParamsDialog;